export const dashboardConstants = {
  
    GET_TOP_CARDS_DASHBOARD_REQUEST: "GET_TOP_CARDS_DASHBOARD_REQUEST",
    GET_TOP_CARDS_DASHBOARD_SUCCESS: "GET_TOP_CARDS_DASHBOARD_SUCCESS",
    GET_TOP_CARDS_DASHBOARD_FAILURE: "GET_TOP_CARDS_DASHBOARD_FAILURE",

    GET_DAILY_JOB_RUN_TRACKER_REQUEST: "GET_DAILY_JOB_RUN_TRACKER_REQUEST",
    GET_DAILY_JOB_RUN_TRACKER_SUCCESS: "GET_DAILY_JOB_RUN_TRACKER_SUCCESS",
    GET_DAILY_JOB_RUN_TRACKER_FAILURE: "GET_DAILY_JOB_RUN_TRACKER_FAILURE",

    GET_PIE_CHARTS_CARDS_DASHBOARD_REQUEST: "GET_PIE_CHARTS_CARDS_DASHBOARD_REQUEST",
    GET_PIE_CHARTS_CARDS_DASHBOARD_SUCCESS: "GET_PIE_CHARTS_CARDS_DASHBOARD_SUCCESS",
    GET_PIE_CHARTS_CARDS_DASHBOARD_FAILURE: "GET_PIE_CHARTS_CARDS_DASHBOARD_FAILURE",

    GET_DISTINCT_CONNECTIONS_REQUEST: "GET_DISTINCT_CONNECTIONS_REQUEST",
    GET_DISTINCT_CONNECTIONS_SUCCESS: "GET_DISTINCT_CONNECTIONS_SUCCESS",
    GET_DISTINCT_CONNECTIONS_FAILURE: "GET_DISTINCT_CONNECTIONS_FAILURE",

  };
  